import React, { useMemo, useCallback } from 'react'
import { Modal, Empty, Typography, Pagination } from 'antd'
import { AntdBaseTable } from '@/components/AntdBaseTable'
import useListFetch from '@/components/ListHooks'
import { queryBreakPriceOrdersByDistributor } from '@/services/breakPrice'
import styles from './index.less'

const EmptyContent = () => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
// eslint-disable-next-line no-magic-numbers
const pageSizeOptions = [10, 20, 30, 50, 100]

const Content = ({ skuId, co, day, skuName }) => {
    const fetch = useCallback(
        props => {
            const dataDayRangeMap = {
                1: 'TODAY',
                3: 'NEARLY_THREE_DAY',
                7: 'NEARLY_SEVEN_DAY',
                15: 'NEARLY_FIFTEEN_DAY',
                30: 'NEARLY_THIRTY_DAY'
            }
            return new Promise((resolve, reject) => {
                queryBreakPriceOrdersByDistributor({
                    channelCoId: co.key,
                    dataDayRange: dataDayRangeMap[day],
                    skuId: skuId,
                    ...props
                }).then(response => {
                    resolve({
                        ...response,
                        data: response.data.list
                    })
                })
            })
        },
        [co.key, day, skuId]
    )

    const { dataSource, loading, pagination } = useListFetch(fetch)

    const goOrder = oid => {
        window.open(`/tradeManage/tower/distribute?oidList=${oid}`)
    }

    const columns = useMemo(
        () => [
            {
                title: '序号',
                code: 'index',
                align: 'center',
                width: 48,
                render: (_, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1
            },
            {
                title: '订单号',
                code: 'oid',
                align: 'center',
                width: 144,
                render: _ => {
                    return <a onClick={() => goOrder(_)}>{_}</a>
                }
            },
            {
                title: '破价商品数',
                code: 'qty',
                align: 'center',
                render: _ => <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }}>{_}</Typography.Paragraph>
            },
            {
                title: '最低分销控价',
                code: 'regulatePrice',
                align: 'center',
                width: 144,
                render: _ => {
                    return <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }}>{_}</Typography.Paragraph>
                }
            },
            {
                title: '买家实付',
                code: 'paidAmount',
                align: 'center',
                width: 144,
                render: _ => {
                    return <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }}>{_}</Typography.Paragraph>
                }
            },
            {
                title: '破价金额',
                code: 'breakPrice',
                align: 'center',
                width: 144,
                render: _ => {
                    return (
                        <Typography.Paragraph style={{ color: '#f53f3f' }} ellipsis={{ rows: 2, tooltip: true }}>
                            {_}
                        </Typography.Paragraph>
                    )
                }
            },
            {
                title: '破价时间',
                code: 'orderDate',
                align: 'center',
                width: 144
            }
        ],
        [pagination]
    )

    return (
        <div>
            <div className={styles.sticky}>
                <div className={styles.header}>
                    <div className={styles.headerItem}>商品编码：{skuId}</div>
                    <div className={styles.headerItem}>商品名称：{skuName}</div>
                    <div className={styles.headerItem}>统计周期：{day === 1 ? '今日' : `近 ${day}日`}</div>
                </div>
            </div>
            <div style={{ height: 500 }}>
                <AntdBaseTable
                    primaryKey="o_id"
                    className={styles.table}
                    dataSource={dataSource}
                    columns={columns}
                    useVirtual={false}
                    useOuterBorder
                    isLoading={loading}
                    components={{ EmptyContent }}
                    stickyTop={0}
                    emptyCellHeight={400}
                />
            </div>
            <div className={styles.footer}>
                <Pagination
                    {...pagination}
                    pageSizeOptions={pageSizeOptions}
                    showQuickJumper={false}
                    showSizeChanger={true}
                    showTotal={_ => `共${_}条记录`}
                />
            </div>
        </div>
    )
}

const BreakPriceDetailModal = ({ visible, onCancel, skuId, co, day, skuName }) => {
    return (
        <Modal
            title="破价订单明细"
            visible={visible}
            onCancel={onCancel}
            width={960}
            bodyStyle={{ padding: '0 24px' }}
            footer={null}
        >
            <Content skuId={skuId} co={co} day={day} skuName={skuName} />
        </Modal>
    )
}

export default BreakPriceDetailModal
